var isBrowser = typeof window !== 'undefined';
const $ = isBrowser ? window.$ : {};
var globalUtils = require('../../utils/utils');

var utils = (function() {

    var _getColorFromDashboardGradientBasedOnPercentile = function(percentile){
        var colorRGBStr = "rgb(0, 0, 0)";

        if(globalUtils.isBrowser){
            if(!$('#dashboard-gradient-canvas').length){
                $('body').append('<canvas id="dashboard-gradient-canvas" style="display: none;"></canvas>');
                var dashboardGradientCanvas = document.getElementById('dashboard-gradient-canvas');
                dashboardGradientCanvas.width = 101;
                dashboardGradientCanvas.height = 10;

                var dashboardGradientCanvasCtx = dashboardGradientCanvas.getContext('2d');

                var dashboardGradient = dashboardGradientCanvasCtx.createLinearGradient(0, 0, 101, 0);
                dashboardGradient.addColorStop(0, '#3eab12');
                dashboardGradient.addColorStop(0.25, '#adc301');
                dashboardGradient.addColorStop(0.5, '#efb007');
                dashboardGradient.addColorStop(0.75, '#f37611');
                dashboardGradient.addColorStop(1, '#d73434');

                dashboardGradientCanvasCtx.fillStyle = dashboardGradient;
                dashboardGradientCanvasCtx.fillRect(0, 0, 101, 10);
            }

            var dashboardGradientCanvasCtx = document.getElementById('dashboard-gradient-canvas').getContext('2d'); // eslint-disable-line
            var data = dashboardGradientCanvasCtx.getImageData(percentile, 0, 1, 1).data;
            colorRGBStr = 'rgb(' + data[0] + ', ' + data[1] + ', ' + data[2] + ')';
        }

        return colorRGBStr;
    }

    var _generateChartGradient = function(ctx, height){
        var gradient = ctx.createLinearGradient(0, 0, 0, height);
        gradient.addColorStop(0, '#d73434');
        gradient.addColorStop(0.25, '#f37611');
        gradient.addColorStop(0.5, '#efb007');
        gradient.addColorStop(0.75, '#adc301');
        gradient.addColorStop(1, '#3eab12');

        return gradient;
    }

    var _getChartVPadding = function(chartInstance){
        var vPadding = 0;
        var layoutPadding = chartInstance.config.options.layout && chartInstance.config.options.layout.padding;
        if(layoutPadding){
            if(typeof layoutPadding === 'number'){
                vPadding = 2 * layoutPadding;
            }else{
                vPadding = (layoutPadding.top || 0) + (layoutPadding.bottom || 0);
            }
        }
        return vPadding;
    }

    var _updateChartGradient = function(chartInstance){
        if(chartInstance.data.datasets.length === 1){
            var chartGradient = _generateChartGradient(chartInstance.ctx, chartInstance.chartArea.bottom - chartInstance.chartArea.top + _getChartVPadding(chartInstance));
            chartInstance.data.datasets.forEach(function(dataset){
                dataset.borderColor
                    = dataset.pointBackgroundColor
                    = dataset.pointHoverBackgroundColor
                    = chartGradient;
            });
        }
    }

    var _getSeverityLevel = function(percentile){
        var severityLevel = '';

        if(percentile > 75){
            severityLevel = 'extreme';
        }else if(percentile > 50){
            severityLevel = 'severe';
        }else if(percentile > 25){
            severityLevel = 'moderate';
        }else if(percentile > 0){
            severityLevel = 'mild';
        }

        return severityLevel;
    }


    return {
        getColorFromDashboardGradientBasedOnPercentile: _getColorFromDashboardGradientBasedOnPercentile,
        updateChartGradient: _updateChartGradient,
        getSeverityLevel: _getSeverityLevel
    };

})();

module.exports = utils;



// WEBPACK FOOTER //
// ./src/common/routes/dashboard/utils.js